import { axiosInstance } from "./axiosInstance";

interface Parameters {
    id:string;
    name:string;
    value:string;
    createdAt:string;
}
export const getParameters = async (): Promise<Parameters[]> => {
  try {
    const response = await axiosInstance.get<Parameters[]>("/api/parameters");
    return response.data;
  } catch (error) {
    console.error('Error ao obter os parâmetros:', error);
    throw error;
  }
};

